import { render, staticRenderFns } from "./successMediationTwo.vue?vue&type=template&id=b5fb6dd4&scoped=true"
import script from "./successMediationTwo.vue?vue&type=script&lang=js"
export * from "./successMediationTwo.vue?vue&type=script&lang=js"
import style0 from "./successMediationTwo.vue?vue&type=style&index=0&id=b5fb6dd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fb6dd4",
  null
  
)

export default component.exports